import { Box, Card, IconButton, Stack, Typography } from '@mui/joy';
import React from 'react';

import classNames from 'classnames';
import { OpenIcon } from '@/shared/icons/Icons';

type Props = {
  children: React.ReactNode;
  icon: React.ReactNode;
  iconBgColor: string;
  route?: string;
  title: string;
  total?: number | string;
  totalClass?: string;
  totalStyle?: React.CSSProperties;
};

const Widget = ({
  children,
  icon,
  iconBgColor,
  route,
  title,
  total,
  totalClass,
  totalStyle,
}: Props) => (
  <Card
    sx={{
      borderRadius: 'xl',
      display: 'flex',
      flexDirection: 'column',
    }}
    variant="plain"
  >
    <Stack
      spacing={1.5}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        minHeight: 0,
      }}
    >
      <Stack alignItems="center" direction="row" justifyContent="space-between">
        <Typography
          level="h1"
          startDecorator={
            <Box
              sx={{
                alignItems: 'center',
                bgcolor: iconBgColor,
                borderRadius: 'md',
                display: 'flex',
                justifyContent: 'center',
                minWidth: 40,
                p: 1.2,
              }}
            >
              {icon}
            </Box>
          }
        >
          {title}
        </Typography>

        <div className="flex flex-row items-center gap-2">
          {total !== undefined && (
            <span className={classNames('text-md font-semibold', totalClass)} style={totalStyle}>
              {total}
            </span>
          )}
          {route && (
            <IconButton
              size="lg"
              variant="plain"
              onClick={() => {
                window.open(route, '_blank', 'noopener,noreferrer');
              }}
            >
              <OpenIcon />
            </IconButton>
          )}
        </div>
      </Stack>

      <Box sx={{ flexGrow: 1, minHeight: 0 }}>{children}</Box>
    </Stack>
  </Card>
);

export default Widget;
